import {useWriteReviewButtonModel} from "../../../hooks/useWriteReviewButtonModel";
import {Button} from "react-bootstrap";
import {FaEdit} from "react-icons/fa";
import * as React from "react";

export const WriteReviewButton = () => {
    const {href} = useWriteReviewButtonModel();
    return (
        <Button variant="success w-100" size="lg" href={href}>
            <FaEdit className="me-1 mb-1"/>Write a Review
        </Button>
    )
}